import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';
import cx from 'clsx';

import { useUpdateCurrentAddressInfo } from '@/hooks';
import { Button } from '@/components';

import style from './index.module.css';
import { AccountModal } from '../AccountModal';

export const DeleteKeyModal = ({ turnOff }: { turnOff(): void }) => {
  const { t } = useTranslation();

  const [successText, setSuccessText] = useState('');
  const [buttonText, setButtonText] = useState('Next');
  const [hideButton, setHideButton] = useState(true);
  const putAccountInfo = useUpdateCurrentAddressInfo();

  const onConfirm = useCallback(() => {
    putAccountInfo({
      account: {
        nonce: 0,
        encryptedPrivateKey: '',
        publicKey: '',
        contract: '',
      },
    });

    setHideButton(false);
    setSuccessText(t('DeleteKeyModal.deleted'));
    setButtonText(t('DeleteKeyModal.okay'));
  }, [putAccountInfo, t]);

  const steps = [
    {
      handler: turnOff,
      textWidth: 64,
      content: (
        <>
          <div className={style.title}>{t('DeleteKeyModal.yk923s')}</div>
          <div className={style.warningText}>{t('DeleteKeyModal.8gbqgj')}</div>
          <div className={style.warningText}>{t('DeleteKeyModal.1wt6vou')}</div>
          <div className={style.footer}>
            <Button className={cx(style.button, style.normalBtn)} onClick={turnOff}>
              {t('DeleteKeyModal.1x9ya0d')}
            </Button>
            <Button type={'primary'} className={style.button} onClick={onConfirm}>
              {t('DeleteKeyModal.xskn2j')}
            </Button>
          </div>
        </>
      ),
    },
  ];

  return (
    <AccountModal
      isLoading={false}
      hideSteps
      headerTitle={t('DeleteKeyModal.deleteTitle')}
      turnOff={turnOff}
      steps={steps}
      hideButton={hideButton}
      successText={successText}
      buttonText={buttonText}
    />
  );
};
